export const publishedWorkoutStatusAsyncLocalChanges = (args, store) => {
    if (args.type === 'CancelBlockWorkout') {
        return handleBlockCancel(args.input, store);
    }
    if (args.type === 'UpdateAthleteWorkoutStatus') {
        return handleAthleteWorkoutStatusUpdate(args.input, store);
    }
    else {
        const _ = args;
        return [];
    }
};
const handleBlockCancel = (input, store) => {
    const { blockId } = input;
    const blockPublishTasks = store.getMany('BlockPublishTask', {
        blockId,
    });
    return [
        ...blockPublishTasks.map((task) => ({
            modelName: 'BlockPublishTask',
            modelId: task.id,
            action: 'delete',
        })),
    ];
};
const handleAthleteWorkoutStatusUpdate = (input, store) => {
    const { blockId } = input;
    const blockPublishTasks = store.getMany('BlockPublishTask', {
        blockId,
    });
    return [
        ...blockPublishTasks.map((task) => ({
            modelName: 'BlockPublishTask',
            modelId: task.id,
            action: 'delete',
        })),
    ];
};
//# sourceMappingURL=published-workout-status-async.js.map